module.exports = __webpack_public_path__ + "media/bootstrap-icons/info-circle-fill-619555c9.svg";